import { render, staticRenderFns } from "./SdkMessage.vue?vue&type=template&id=169971cc&"
import script from "./SdkMessage.vue?vue&type=script&lang=js&"
export * from "./SdkMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('169971cc')) {
      api.createRecord('169971cc', component.options)
    } else {
      api.reload('169971cc', component.options)
    }
    module.hot.accept("./SdkMessage.vue?vue&type=template&id=169971cc&", function () {
      api.rerender('169971cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Information/SdkMessage.vue"
export default component.exports